export default __webpack_public_path__ + "1e8e01ee41e6cef7b623d91eaba7caba.png";